import apiAxios from './axios'

const urlPrefix='im/m/person/'
const urlWebPrefix='im/web/person/'

/**
 * 发送简历消息
 * @returns {AxiosPromise}
 * @param userId
 * @param toUserId
 * @param resumeId
 */
export function sendResumeChat(userId,toUserId,resumeId) {
    return apiAxios({
        url: urlPrefix+'sendResumeChat',
        method: 'post',
        data: {
            userId:userId,
            toUserId:toUserId,
            resumeId:resumeId,
        }
    })
}

export function chatNetRecommendJobs(jobfair_id,limit=15,page=1) {
    return apiAxios({
        url: urlPrefix+'chatNetRecommendJobs',
        method: 'post',
        data: {
            jobfair_id:jobfair_id,
            limit:limit,
            page:page,
        }
    })
}

export function agreeSendResume(userId, toUserId, resumeId, msgId,){
    return apiAxios({
        url: urlPrefix+'agreeSendResume',
        method: 'post',
        data: {
            userId:userId,
            toUserId:toUserId,
            resumeId:resumeId,
            msgId:msgId,
        }
    })
}
export function refuseSendResume(userId, toUserId, msgId){
    return apiAxios({
        url: urlPrefix+'refuseSendResume',
        method: 'post',
        data: {
            userId:userId,
            toUserId:toUserId,
            msgId:msgId,
        }
    })
}

/**
 * 个人-企业 发起洽谈
 * @param jobId
 * @param jobfair_id
 * @returns {*}
 */
export function netTalkPerson(jobId,jobfair_id){
    return apiAxios({
        url: urlWebPrefix+'netTalkPerson',
        method: 'post',
        data: {
            id:jobId,
            jobfair_id:jobfair_id,
            is_mobile: 1
        }
    })
}
export function applyResume(jobId,resumeId,is_temp){
    return apiAxios({
        url: '/content/jobfair/person/apply',
        method: 'post',
        data: {
            is_apply:1,
            job_id:jobId,
            resume_id:resumeId,
            is_temp:is_temp
        }
    })
}